export default "__VITE_ASSET__CywQ5iyJ__"